import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { id: "container" }
const _hoisted_2 = { id: "navbar" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { style: {"color":"white","display":"flex","column-gap":"8px"} }
const _hoisted_5 = { id: "sidebar" }
const _hoisted_6 = { class: "list" }
const _hoisted_7 = { id: "inner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { style: {"padding":"0 20px"} }, [
        _createElementVNode("a", { href: "" }, [
          _createElementVNode("img", {
            height: "30",
            src: "https://referon.it/files/logo_dark_sm.png",
            alt: ""
          })
        ])
      ], -1)),
      (_ctx.store.admin.role !== 'SUPER')
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.store.admin!.organization!.name), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "btn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
      }, [
        _createElementVNode("span", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("b", null, "Esci", -1)),
          _createVNode(_component_font_awesome_icon, { icon: "power-off" })
        ])
      ])
    ]),
    _createElementVNode("main", null, [
      _createElementVNode("nav", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_ctx.store.admin.role === 'SUPER')
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: _normalizeClass(_ctx.isCurrent('organizations')),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigate('organizations')))
              }, "Strutture", 2))
            : _createCommentVNode("", true),
          _createElementVNode("a", {
            class: _normalizeClass(_ctx.isCurrent('users')),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigate('users')))
          }, "Utenti", 2),
          (_ctx.store.admin.role !== 'SUPER')
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: _normalizeClass(_ctx.isCurrent('upload')),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.navigate('upload')))
              }, "Upload documento", 2))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_router_view)
      ])
    ])
  ]))
}